import React from 'react';
import styled from 'styled-components';
import closeIcon from '../img/closeIcon.png';
import OshiHeader from './OshiHeader';

const Modal = ({ onClose, children, header, containerStyle, hideCloseButton }) => {
  return (
    <PageContainer>
      <Overlay />
      <FlexContainer>
        <ContentContainer style={ containerStyle }>
          {header && <OshiHeader />}
          { !hideCloseButton &&
            <CloseContainer>
              <Icon src={closeIcon} onClick={onClose} />
            </CloseContainer>
          }
          {children}
        </ContentContainer>
      </FlexContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 200;
  @media (max-width: 768px) {
    height: 100%;
    z-index: 12;
  }
  @media (max-width: 900px) and (orientation: landscape) {
    height: 200%;
    width: 100vw;
  }
`;
const Overlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: #3b5b80;
  opacity: 0.5;
  z-index: 0;
  @media (max-width: 900px) and (orientation: landscape) {
    height: 100%;
    width: 100vw;
  }
`;
const FlexContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  z-index: 10;
`;
const ContentContainer = styled.div`
  position: relative;
  top: 70px;
  width: 624px;
  min-height: 357px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  padding-top: ${(props) => (props.native ? '8%' : '0')};
  align-items: center;
  @media (max-width: 768px) {
    position: relative;
    top: 0px;
    width: 100%;
    height: 100%;
    justify-content: flex-start;
  }
`;

const CloseContainer = styled.div`
  width: 95%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 768px) {
    position: relative;
    top: 10px;
    justify-content: flex-start;
    margin-top: 0px;
    padding: 0px 0px;
    height: 30px;
  }
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
  @media (max-width: 420px) {
    position: absolute;
    z-index: 1000;
  }
`;
export default Modal;
